<template>
  <fragment>
    <AppBody
      title="Vendas / Envio de Ingressos"
      :subtitle="pageSubtitle"
      :actions="actions"
      :info="infoMessage"
      infoMessage="Configuração pendente! Contate o administrador ou revise a definição de taxas no cadastro da Loja"
      :disableActions="disableActions"
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form @submit.prevent="filterPackages" class="search-forms">
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  tabindex="1"
                  :label="$t('sales.ticket_date_interval')"
                  :items="$ticketPackage.intervalo_data"
                  item-text="text"
                  item-value="value"
                  v-model="filter.intervalo_datas"
                  :placeholder="$t('sales.ticket_date_interval_placeholder')"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                sm="4"
                v-if="filter.intervalo_datas != 'custom'"
              >
                <v-menu
                  tabindex="9"
                  ref="menu"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  v-model="menu"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <BaseTextField
                      clearable
                      :label="$t('sales.dates')"
                      v-model="dateRangeOrders"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar-blank-outline"
                      :placeholder="placeholderData"
                      :error-messages="filter.error.range_dates"
                      :disabled="filter.intervalo_datas != null ? false : true"
                      @input="filter.error.range_dates = []"
                      @click:clear="
                        $ticketPackage.clearFilterFields(
                          'pacote_ingresso_dates'
                        )
                      "
                    />
                  </template>
                  <v-date-picker
                    v-model="computeRangeOrders"
                    :active-picker.sync="activePickerOrders"
                    @change="computeRangeOrders"
                    locale="pt"
                    :header-color="$config.dados.corinputs"
                    landscape
                    :color="$config.dados.corinputs"
                    range
                    @click:month="monthEvent"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" sm="4" v-else>
                <v-menu
                  tabindex="10"
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <BaseTextField
                      clearable
                      :label="$t('sales.dates')"
                      v-model="dateRangeOrders"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar-blank-outline"
                      :placeholder="placeholderData"
                      :error-messages="filter.error.range_dates"
                      :disabled="filter.intervalo_datas != null ? false : true"
                      @input="filter.error.range_dates = []"
                      @click:clear="
                        $ticketPackage.clearFilterFields(
                          'pacote_ingresso_dates'
                        )
                      "
                    />
                  </template>
                  <v-date-picker
                    v-model="filter.range_dates"
                    :active-picker.sync="activePickerOrders"
                    locale="pt"
                    :header-color="$config.dados.corinputs"
                    landscape
                    :color="$config.dados.corinputs"
                    range
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :items="$ticketPackage.status_pedido"
                  item-text="value"
                  item-value="key"
                  :label="$t('sales.select_status')"
                  v-model="filter.status"
                />
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.ticket_costumer')"
                  tabindex="3"
                  :placeholder="$t('sales.ticket_costumer_placeholder')"
                  v-model="filter.consumidor"
                  @click:clear="$ticketPackage.clearFilterFields('consumidor')"
                />
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseAutocomplete
                  :label="$t('sales.ticket_payment_method')"
                  item-text="key"
                  item-value="value"
                  :placeholder="$t('sales.ticket_payment_method_placeholder')"
                  :no-data-text="$t('sales.no_payment_method')"
                  :items="formaPag"
                  v-model="filter.forma_pag"
                />
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton variant="filter" type="submit">
                  {{ $t('common.filter') }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="rounded-lg"
          :no-data-text="$t('sales.no_packages')"
          :loading-text="$t('sales.loading_packages_information')"
          mobile-breakpoint="0"
          :loading="loadingPackages"
          :headers="headersTable"
          :sort-by="sortBy"
          :sort-desc="true"
          :items="allTicketPackages"
          :items-per-page="10"
          :header-props="{
            class: 'rounded-t-lg',
            color: $config.dados.corinputs,
          }"
          :footer-props="{
            class: 'rounded-b-lg',
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: this.$t('sales.packages_per_page'),
          }"
        >
          <template v-slot:item.total="{ item }">
            {{ item.total | moeda }}
          </template>
          <template v-slot:item.dthr="{ item }">
            {{ formatProductDateToTable(item.dthr) }}
          </template>
          <template v-slot:item.metodo_pagamento="{ item }">
            {{ metodoPagamentoExibicao(item.metodo_pagamento) }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ formatOrderStatus(item.status) }}
          </template>
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    height="30"
                    width="30"
                    small
                    v-bind="attrs"
                    v-on="on"
                    :color="$config.dados.corinputs"
                    :disabled="item.status !== 'RE'"
                    @click="copyText"
                    class="mr-2"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('sales.ticket_copy_cart_link') }}</span> </v-tooltip
              ><v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    height="30"
                    width="30"
                    small
                    class="mr-2"
                    :color="$config.dados.corinputs"
                    :loading="item.edit_button_loading"
                    :disabled="item.status === 'CA'"
                    v-bind="attrs"
                    v-on="on"
                    @click="openModal('send', item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('sales.ticket_edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    :color="$config.dados.corinputs"
                    :disabled="item.status !== 'PA'"
                    @click="
                      $ticketPackage.removePackage(
                        item.idpedido,
                        $t('sales.ticket_cancel_confirmation')
                      )
                    "
                  >
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('sales.ticket_cancel') }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <TicketPackageModal />
        <ConfirmDialog
          :dialogText="$ticketPackage.text"
          @callback="$ticketPackage.cancelPackage"
        />
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";
import TicketPackageModal from "@/components/vendas/TicketPackageModal.vue";
import ConfirmDialog from "@/components/global/ConfirmDialog.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
import {
  formatOrderStatus,
  formatProductDateToTable,
} from "@/utils/productPackage.js";
export default {
  name: "TicketPackage",
  metaInfo: {
    title: "Envio de Ingressos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Envio de Ingressos | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
    TicketPackageModal,
    ConfirmDialog,
    ExpansionPanelFilters,
  },
  data() {
    return {
      sortBy: "dthr",
      formatOrderStatus,
      formatProductDateToTable,
      dayjs: dayjs,
      activePickerOrders: null,
      activePickerRelease: null,
      date: null,
      menu: false,
      menu4: false,
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      disableConsumidor: true,
      tipo_pessoa: [],
      filter: {
        intervalo_datas: "",
        range_dates: [],
        status: "",
        consumidor: "",
        forma_pag: "",
        error: {
          range_dates: [],
        },
      },
    };
  },
  watch: {
    "filter.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          this.filter.range_dates = [currentDay, currentDay];
          this.filter.hora_inicial = "00:00";
          this.horaInicial = "00:00";
          this.$ticketPackage.filter.hora_final = "23:59";
          this.horaFinal = "23:59";
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.filter.range_dates = [currentDayWeek, week];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.filter.range_dates = [currentDayMonth, month];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.filter.range_dates = [currentDayCustom, custom];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.filter.range_dates = [defaultDay, defaultDayCustom];
          break;
        }
      }
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (val && this.filter.intervalo_datas == "date") {
            this.activePickerOrders = "DATE";
          } else if (val && this.filter.intervalo_datas == "week") {
            this.activePickerOrders = "DATE";
          } else if (val && this.filter.intervalo_datas == "month") {
            this.activePickerOrders = "MONTH";
          } else if (val && this.filter.intervalo_datas == "custom") {
            this.activePickerOrders = "DATE";
          } else {
            this.activePickerOrders = "DATE";
          }
        });
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "HOUR"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    dateRangeOrders(e) {
      if (e) {
        this.filter.error.range_dates = [];
      }
    },
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "storeInfo",
      "allTicketPackages",
      "loadingPackages",
    ]),
    headersTable() {
      return [
        {
          text: this.$t('sales.registration_date'),
          align: "center",
          value: "dthr",
          width: 200,
        },
        {
          text: this.$t('sales.buyer'),
          align: "center",
          value: "nome",
          width: 200,
        },
        {
          text: this.$t('sales.purchase_value'),
          align: "center",
          value: "total",
          width: 200,
        },
        {
          text: this.$t('sales.ticket_itens'),
          align: "center",
          value: "qtd_item",
          width: 200,
        },
        {
          text: this.$t('sales.ticket_payment_method_short'),
          align: "center",
          value: "metodo_pagamento",
          width: 200,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          width: 200,
        },
        {
          text: this.$t('sales.ticket_actions'),
          align: "center",
          value: "actions",
          width: 200,
        },
      ]
    },
    actions() {
      return [
        {
          name: this.$t('sales.new_package'),
          action: () => this.openModal("new", ""),
          id: "NEW",
        },
      ]
    },
    infoMessage() {
      return this.disableActions;
    },
    disableActions() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return this.verifyPackageTax;
      return this.verifyPackageTaxLojista;
    },
    verifyPackageTax() {
      return (
        this.storeInfo?.aplica_taxa_pacote == 0 ||
        (this.storeInfo?.aplica_taxa_gratuidade == 0 &&
          this.storeInfo?.aplica_taxa_cortesia == 0)
      );
    },
    verifyPackageTaxLojista() {
      return (
        this.$axios.getLocal("oe_user_info")?.data?.aplica_taxa_pacote == 0 &&
        this.$axios.getLocal("oe_user_info")?.data?.aplica_taxa_gratuidade ==
          0 &&
        this.$axios.getLocal("oe_user_info")?.data?.aplica_taxa_cortesia == 0
      );
    },
    pacoteIngressos() {
      return _.orderBy(
        this.$ticketPackage.pacotes_ingressos,
        ["dthr"],
        ["desc"]
      );
    },
    consumidorFiltred() {
      const packagePermission = this.$loja_consumidor.consumidores.filter(
        item => item.permite_pacote === 1
      );

      packagePermission.forEach(item => {
        item.nome = item.nome || item.razao_social;
      });

      return packagePermission;
    },
    pageSubtitle() {
      if (this.storeInfo && this.isAdmin)
        return this.$t('sales.ticket_package_title') + " - " + this.storeInfo.nome_loja;
      return this.$t('sales.ticket_package_title');
    },
    formaPag() {
      return this.$ticketPackage.lista_forma_pagamento;
    },
    tableValues() {
      return this.$ticketPackage.cupons_descontos;
    },
    computeRangeOrders: {
      get() {
        return this.filter.range_dates;
      },
      set([firstDay]) {
        switch (this.filter.intervalo_datas) {
          case "date": {
            this.filter.range_dates = [firstDay, firstDay];
            break;
          }
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.filter.range_dates = [currentDayWeek, week];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.filter.range_dates = [currentDayMonth, month];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.filter.range_dates = [currentDayCustom, custom];
            break;
          }
          default: {
            const defaultDay = "";
            this.filter.range_dates = [firstDay, defaultDay];
            break;
          }
        }
      },
    },
    dateRangeOrders() {
      let arrayDates = [];
      if (this?.filter?.range_dates !== "") {
        this?.filter?.range_dates?.forEach(item => {
          return arrayDates.push(this.$config.convertDataBR(item));
        });
        return arrayDates.join(" ~ ");
      }

      return [];
    },
  },
  methods: {
    ...mapActions(["fetchTicketPackages", "fetchEvents"]),
    filterPackages() {
      this.fetchTicketPackages({
        producerId: this.storeSequencial,
        status: this.filter.status,
        dthr_pacote_ini: this.filter.range_dates[0]
          ? this.filter.range_dates[0] + " 00:00"
          : "",
        dthr_pacote_fim: this.filter.range_dates[1]
          ? this.filter.range_dates[1] + " 23:59"
          : "",
        nome: this.filter.consumidor,
        metodo_pagamento: this.filter.forma_pag,
      });
    },
    metodoPagamentoExibicao(item) {
      if (item === null) {
        return "-";
      } else if (item === "QRCODE") {
        return "PIX";
      } else {
        return item;
      }
    },
    copyText() {
      const slug = this.$axios.getLocal("slug_loja_pacote").data;
      navigator.clipboard.writeText(`https://${slug}.eleven360.com/carrinho`);
      this.$config.alert(
        this.$t('sales.ticket_copied_cart_link'),
        this.$config.dados.successColor
      );
    },
    openModal(type, data) {
      if (type === "send") {
        this.$ticketPackage.packageProductStep = 3;
      } else {
        this.$ticketPackage.packageProductStep = 1;
      }

      this.fetchEvents({ producerId: this.storeSequencial });

      if (data) {
        const {
          status,
          idconsumidor,
          desconto_pacote,
          dthr_expira,
          metodo_pagamento,
          tipo_envio,
          canal_envio,
        } = data;
        let date = dthr_expira.split(" ");
        this.$ticketPackage.cadastro.exp_hor = date[1];
        this.$ticketPackage.cadastro.exp_dia = dayjs(
          date[0],
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
        this.$ticketPackage.sendPackageInfo.push(data);
        this.$ticketPackage.cadastro.status = status;
        this.$ticketPackage.cadastro.consumidor = idconsumidor;
        this.$ticketPackage.cadastro.desconto = desconto_pacote;
        this.$ticketPackage.cadastro.metodo_pagamento = metodo_pagamento;
        this.$ticketPackage.sendChannel = canal_envio || "EMAIL";
        this.$ticketPackage.sendType = tipo_envio || "MULTIPLO";
        this.$ticketPackage.getPackageItems(data);
      }
      this.$ticketPackage.addPackage = true;
      this.$ticketPackage.type = type;
    },
    openModalSelect() {
      this.$ticketPackage.pacotes_ingressos = [];
      this.$ticketPackage.loja_selecionada = "";
      this.$ticketPackage.modalSelectStore = true;
    },
    save2(hour) {
      this.$refs.menu2.save(hour);
      this.horaInicial = hour;
    },
    save3(hour) {
      this.$refs.menu3.save(hour);
      this.horaFinal = hour;
    },
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$ticketPackage.filter.range_dates = [currentDayMonth, monthEnd];
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.key.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  mounted() {
    this.$ticketPackage.getPaymentMethods();
    this.$ticketPackage.getOrdersStatus();
    this.$loja_consumidor.getConsumidor(this.storeSequencial);
  },
  beforeMount() {
    // this.$loja_consumidor.getConsumidor();
    // this.$ticketPackage.getPackageTickets();
    this.fetchTicketPackages({
      producerId: this.storeSequencial,
      ...this.filter,
    });
  },
  destroyed() {
    this.$ticketPackage.clearModalPacoteIngresso("filter");
  },
};
</script>
<style></style>
